import { render, staticRenderFns } from "./CaseMedications.vue?vue&type=template&id=49b5f608&scoped=true&"
import script from "./CaseMedications.vue?vue&type=script&lang=js&"
export * from "./CaseMedications.vue?vue&type=script&lang=js&"
import style0 from "./CaseMedications.vue?vue&type=style&index=0&id=49b5f608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b5f608",
  null
  
)

export default component.exports